import React, { useEffect, useState } from 'react';
import { mucPhaiThuChiTietApi } from '../../../api/mucPhaiThuChiTietApi';
import { showNotify } from '../../../helpers/toast';
import { sf_mucphaithu_viewmodel } from '../../../models/response/thu-phi/sf_mucphaithu';
import { sf_mucphaithu_chitiet_viewmodel } from '../../../models/response/thu-phi/sf_mucphaithu_chitiet';
import styles from "./HoanPhiDaTao.module.css";
import { DataGrid } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
interface IHoanPhiDaTaoProps {
    sf_mucphaithu_id: number,
    sf_mucphaithu: sf_mucphaithu_viewmodel
}
const HoanPhiDaTao = (props: IHoanPhiDaTaoProps) => {
    const [mucPhaiThuChiTiets, setMucPhaiThuChiTiets] = useState<sf_mucphaithu_chitiet_viewmodel[]>([]);
    useEffect(() => {
        handletGetMucPhaiThuChiTietAsync();
    }, [props.sf_mucphaithu_id])
    const handletGetMucPhaiThuChiTietAsync = async () => {
        const res = await mucPhaiThuChiTietApi.selectByMucPhaiThu(props.sf_mucphaithu_id);
        if (res.is_success) {            
            setMucPhaiThuChiTiets(res.data.map((x: any) => {
                return {
                    ...x,
                    so_tien_hoan_phi: x.so_tien_phai_nop
                }
            }))
        } else {
            showNotify({ message: "Không tải được chứng từ" , type:'error'})
        }
    }
    return (
        <div className={styles.container}>
            {/* {console.log(props.sf_mucphaithu)} */}
            <p className={styles.cation}>Số chứng từ: {props.sf_mucphaithu.so_chung_tu}</p>
            <div className={styles.mucPhiThuInfo}>
                <DataGrid
                    dataSource={mucPhaiThuChiTiets}
                    keyExpr='id'
                    showRowLines={true}
              
                >
                    <Column caption={"Nhóm"} dataField={"ten_khoan_nop_group"} allowEditing={false} />
                    <Column caption={"Tên khoản nộp"} dataField={"ten_khoan_nop"} allowEditing={false} />
                    <Column caption={"Phải nộp"} dataField={"so_tien_phai_nop"} format={"0,###"} allowEditing={false} />                   
                </DataGrid>
            </div>
        </div>
    );
};

export default HoanPhiDaTao;